<template>
  <div class="sp-root">
    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="service-package-dialog-box"
      @closed="onClose"
    >
      <div
        class="carousel"
        ref="wrapper"
        v-loading.lock="loading"
        element-loading-background="rgba(255, 255, 255, 0.6)"
        @mouseenter="showNav = true"
        @mouseleave="showNav = false"
      >
        <div class="track" ref="track" :style="trackStyle">
          <div
            v-for="(pkg, idx) in list"
            :key="pkg.id"
            class="page-item"
            :class="{ active: idx === cur }"
          >
            <div class="page-inner">
              <h2 class="page__title">{{ pkg.title }}</h2>
              <p v-if="pkg.subtitle" class="page__sub">{{ pkg.subtitle }}</p>
              <div class="divider"></div>
              <div class="page__summary">
                <div class="text">{{ pkg.summary }}</div>
              </div>
              <div class="page__meta" v-if="pkg.rangeType === 20">
                <span>有效期：{{ pkg.startDate }} 至 {{ pkg.endDate }}</span>
              </div>
              <div class="divider"></div>
              <div class="page__list">
                <div v-for="(it, i) in sortedItems" :key="it.id" class="row">
                  <em><i class="el-icon-check"></i></em>
                  <span>{{ it.content }}</span>
                </div>
                <p v-if="!sortedItems.length" class="none">暂无服务内容</p>
              </div>
              <div class="page__action">
                <el-button class="detail-btn" round @click="showDetail" v-if="hasPermission('服务详情')">
                  {{$l('了解服务详情')}}
                  <i class="el-icon-arrow-right"></i>
                </el-button>
                <el-button class="contact-btn" round @click="contactMe" v-if="hasPermission('新增服务')">
                  {{$l('请业务人员联系我')}}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <transition name="nav-fade">
          <div
            v-if="showNav && cur > 0"
            class="nav-arrow nav-prev"
            @click.stop="prev"
          >
            <span></span>
          </div>
        </transition>
        <transition name="nav-fade">
          <div
            v-if="showNav && cur < list.length - 1"
            class="nav-arrow nav-next"
            @click.stop="next"
          >
            <span></span>
          </div>
        </transition>
      </div>
      <div class="dots">
        <span
          v-for="(pkg, idx) in list"
          :key="idx"
          class="dot"
          :class="{ on: idx === cur }"
          @click.stop="goTo(idx)"
        ></span>
      </div>
      <div class="dialog-close" @click="dialogVisible = false">
        <i class="el-icon-close"></i>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="detailVisible"
      :title="$l('服务详情')"
      :close-on-click-modal="false"
      width="960px"
      :custom-class="
        'detail-dialog-box' + (detailFullscreen ? ' detail-fullscreen' : '')
      "
    >
      <div
        class="detail-fullscreen-btn"
        :title="detailFullscreen ? '退出全屏' : '全屏'"
        @click="toggleDetailFullscreen"
      >
        <i class="el-icon-full-screen"></i>
      </div>
      <div
        v-if="detailType === 1"
        class="detail-content"
        v-html="detailContent"
      ></div>
      <div v-else class="detail-file">
        <el-image
          v-if="detailIsImage"
          :src="detailUrl"
          class="detail-image"
        ></el-image>
        <iframe
          v-else-if="detailIsPdf"
          :src="detailUrl"
          class="detail-pdf"
        ></iframe>
        <p v-else class="file-none">暂不支持预览该类型文件</p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="contactVisible"
      :title="$l('维保服务套餐表单')"
      :close-on-click-modal="false"
      width="560px"
      custom-class="contact-dialog-box"
    >
      <el-form
        ref="contactForm"
        :model="contactForm"
        :rules="contactRules"
        label-width="130px"
        size="medium"
        class="contact-form"
      >
        <el-form-item :label="$l('联系人姓名')" prop="userName">
          <el-input
            v-model="contactForm.userName"
            :placeholder="$l('请输入联系人姓名')"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$l('联系手机号')" prop="phone">
          <el-input
            v-model="contactForm.phone"
            :placeholder="$l('请输入联系手机号')"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$l('项目所在地')" prop="area">
          <el-cascader
            v-model="contactForm.area"
            :options="areaOptions"
            :props="areaProps"
            :placeholder="$l('请选择项目所在地')"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item :label="$l('感兴趣的服务')" prop="serviceList">
          <el-checkbox-group v-model="contactForm.serviceList">
            <el-checkbox v-for="sv in serviceTitles" :key="sv" :label="sv">{{
              $l(sv)
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$l('备注')" prop="remark">
          <el-input
            v-model="contactForm.remark"
            type="textarea"
            :rows="3"
            :placeholder="$l('请输入备注')"
            @input="remarkInput"
          ></el-input>
          <div class="remark-count">{{ remarkCount }}/500</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="contact-footer">
        <el-button @click="contactCancel">{{$l('取 消')}}</el-button>
        <el-button type="primary" class="contact-submit" @click="submitContact"
          >{{$l('提 交')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/mixins/global.js";

export default {
  name: "servicePackage",
  mixins: [global],
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      dialogVisible: false,
      detailVisible: false,
      detailFullscreen: false,
      list: [],
      cur: 0,
      showNav: false,
      loading: false,
      contactVisible: false,
      areaOptions: [],
      areaProps: {
        value: "name",
        label: "name",
        children: "cityVos",
        checkStrictly: true,
      },
      contactForm: {
        userName: "",
        phone: "",
        area: [],
        serviceList: [],
        remark: "",
      },
      contactRules: {
        userName: [
          { required: true, message: this.$l("请输入联系人姓名"), trigger: "blur" },
        ],
        phone: [
          { required: true, message: this.$l("请输入联系手机号"), trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$l("手机号格式不正确"),
            trigger: "blur",
          },
        ],
        area: [
          {
            type: "array",
            required: true,
            len: 2,
            message: this.$l("请选择项目所在地"),
            trigger: "change",
          },
        ],
        serviceList: [
          {
            type: "array",
            required: true,
            min: 1,
            message: this.$l("请选择感兴趣的服务"),
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    visible(v) {
      this.dialogVisible = v;
      if (v) this.load();
    },
    dialogVisible(v) {
      this.$emit("update:visible", v);
    },
    detailVisible(v) {
      if (!v) this.detailFullscreen = false;
    },
  },
  computed: {
    sortedItems() {
      const items = this.list[this.cur] && this.list[this.cur].items;
      return items ? [...items].sort((a, b) => a.orderNum - b.orderNum) : [];
    },
    trackStyle() {
      return {
        transform: "translateX(" + -this.cur * 400 + "px)",
        transition: "transform 0.3s ease",
      };
    },
    detailType() {
      const pkg = this.list[this.cur];
      return pkg && Number(pkg.contentType) === 2 ? 2 : 1;
    },
    detailContent() {
      const pkg = this.list[this.cur];
      return pkg ? pkg.content : "";
    },
    detailUrl() {
      const pkg = this.list[this.cur];
      return pkg ? pkg.contentUrl : "";
    },
    detailIsImage() {
      return /\.(jpe?g|png|gif|bmp|webp)(\?.*)?$/i.test(this.detailUrl || "");
    },
    detailIsPdf() {
      return /\.pdf(\?.*)?$/i.test(this.detailUrl || "");
    },
    serviceTitles() {
      return this.list.map((d) => d.title).filter(Boolean);
    },
    remarkCount() {
      return (this.contactForm.remark || "").replace(/(^\s*)|(\s*$)/g, "")
        .length;
    },
  },
  methods: {
    load() {
      this.loading = true;
      this.$http.get(this.$apiConfig.get_fd_service_package_list_url).then(
        (r) => {
          this.loading = false;
          const res = r.data || {};
          if (res.code !== 0) {
            this.message(res.code, res.msg);
            this.$emit("close");
            return;
          }
          this.list = (res.data || []).filter((d) => d.status === 10);
          this.cur = 0;
        },
        (e) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(e);
          this.$emit("close");
        }
      );
    },
    goTo(i) {
      if (i >= 0 && i < this.list.length) this.cur = i;
    },
    prev() {
      if (this.cur > 0) this.cur--;
    },
    next() {
      if (this.cur < this.list.length - 1) this.cur++;
    },
    showDetail() {
      this.detailVisible = true;
    },
    toggleDetailFullscreen() {
      this.detailFullscreen = !this.detailFullscreen;
    },
    contactMe() {
      const pkg = this.list[this.cur];
      this.contactForm.serviceList = pkg && pkg.title ? [pkg.title] : [];
      this.areaOptions = [];
      this.loadAreaList();
      this.contactVisible = true;
    },
    loadAreaList() {
      this.$http.get(this.$apiConfig.get_fd_province_city_list_url).then(
        (r) => {
          this.areaOptions = (r.data.data || []).map((p) => ({
            name: p.provinceName,
            cityVos: p.cityVos || [],
          }));
        },
        (e) => {
          this.errorMessage(5);
          this.$sentry.captureException(e);
        }
      );
    },
    contactCancel() {
      this.contactVisible = false;
      this.$refs.contactForm && this.$refs.contactForm.resetFields();
    },
    remarkInput(val) {
      const meaningful = val.replace(/(^\s*)|(\s*$)/g, "").length;
      if (meaningful > 500) {
        this.contactForm.remark = val
          .replace(/(^\s*)|(\s*$)/g, "")
          .slice(0, 500);
      }
    },
    submitContact() {
      this.$refs.contactForm.validate((valid) => {
        if (!valid) return;
        const area = this.contactForm.area || [];
        const data = {
          userName: (this.contactForm.userName || "").trim(),
          phone: (this.contactForm.phone || "").trim(),
          province: area[0] || "",
          city: area[1] || "",
          serviceList: this.contactForm.serviceList,
          remark: (this.contactForm.remark || "").trim(),
        };
        this.$http
          .post(this.$apiConfig.add_fd_service_package_business_url, data)
          .then(
            (r) => {
              const res = r.data;
              this.message(res.code, res.msg);
              if (res.code === 0) {
                this.contactVisible = false;
                this.$refs.contactForm.resetFields();
              }
            },
            (e) => {
              this.errorMessage(1);
              this.$sentry.captureException(e);
            }
          );
      });
    },
    onClose() {
      this.cur = 0;
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .service-package-dialog-box {
  position: relative;
  background: transparent;
  border-radius: 12px;
  box-shadow: none;
  width: 400px !important;
  max-height: 80vh;
  padding: 0 !important;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
/deep/ .service-package-dialog-box .el-dialog__header {
  display: none !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
}
/deep/ .service-package-dialog-box .el-dialog__body {
  padding: 0 !important;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
/deep/ .service-package-dialog-box .el-dialog__footer {
  display: none !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
}
/deep/ .detail-dialog-box {
  width: 960px !important;
  .el-dialog__body {
    padding: 0 !important;
  }
}
/deep/ .detail-dialog-box .el-dialog__header {
  text-align: center;
}
/deep/ .detail-dialog-box.detail-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    .detail-content {
      flex: 1;
      min-height: 0;
      max-height: none;
    }
    .detail-file {
      flex: 1;
      min-height: 0;
      height: auto;
      max-height: none;
    }
  }
}
.detail-fullscreen-btn {
  position: absolute;
  top: 20px;
  right: 44px;
  color: #909399;
  cursor: pointer;
  z-index: 20;
  font-size: 16px;
  line-height: normal;
  transition: color 0.3s;
  &:hover {
    color: #409eff;
  }
}
/deep/ .contact-dialog-box .el-dialog__header {
  text-align: center;
  color: #1f2d3d;
  font-weight: 700;
}
.contact-form {
  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }
  /deep/ .el-cascader {
    width: 100%;
  }
  /deep/ .el-checkbox-group {
    line-height: 1.2;
  }
  /deep/ .el-checkbox {
    margin-right: 16px;
    margin-bottom: 10px;
    white-space: nowrap;
  }
  /deep/ .el-checkbox__label {
    white-space: nowrap;
  }
}
/deep/ .contact-dialog-box .el-dialog__body {
  padding-bottom: 6px !important;
}
.contact-footer {
  text-align: center;
  padding-top: 6px;
}
/deep/ .contact-dialog-box .el-dialog__footer {
  padding: 6px 20px 18px;
}
.remark-count {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1;
  color: #909399;
  text-align: right;
}
.contact-footer .contact-submit {
  background: #f56c6c;
  border-color: #f56c6c;
  &:hover,
  &:focus {
    background: #f78989;
    border-color: #f78989;
  }
}
.detail-content {
  padding: 16px 20px;
  font-size: 13px;
  color: #606266;
  line-height: 1.8;
  white-space: pre-line;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  overflow-x: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
  box-sizing: border-box;
  /deep/ p {
    margin: 0 0 8px;
  }
  /deep/ img,
  /deep/ table {
    max-width: 100%;
  }
}
.detail-file {
  display: flex;
  overflow: auto;
  width: 100%;
  height: calc(100vh - 160px);
  max-height: calc(100vh - 160px);
  padding: 16px 20px;
  box-sizing: border-box;
  .detail-image {
    flex: none;
    margin: auto;
    width: auto;
    height: auto;
    overflow: visible;
    /deep/ img {
      display: block;
      width: auto;
      height: auto;
      max-width: none;
      max-height: none;
    }
  }
  .detail-pdf {
    width: 100%;
    height: 100%;
    border: none;
  }
  .file-none {
    margin: auto;
    text-align: center;
    color: #c0c4cc;
    font-size: 13px;
  }
}
.dialog-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.05);
  color: #909399;
  cursor: pointer;
  z-index: 20;
  transition: all 0.3s;
  &:hover {
    background: #f56c6c;
    color: #fff;
  }
}
.carousel {
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 560px;
}
.track {
  flex: 1;
  display: flex;
  min-height: 0;
  align-items: stretch;
  margin: 0;
  padding: 0;
}
.page-item {
  flex-shrink: 0;
  width: 400px;
  height: 100%;
  flex-shrink: 0;
  transition: opacity 0.3s;
  opacity: 0.2;
  .page-inner {
    height: 100%;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin: 0;
    padding: 24px;
    overflow: hidden;
  }
  &.active {
    opacity: 1;
  }
}
.page__title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
  text-align: center;
}
.page__sub {
  margin: 0 0 8px;
  font-size: 13px;
  color: #909399;
  text-align: center;
}
.divider {
  height: 1px;
  background: #ebeef5;
  margin: 12px 0;
}
.page__summary {
  margin: 0;
  .text {
    font-size: 13px;
    color: #606266;
    line-height: 1.8;
    white-space: pre-line;
  }
}
.page__meta {
  margin: 0 0 10px;
  padding: 4px 10px;
  background: #ecf5ff;
  border-radius: 4px;
  border-left: 3px solid #409eff;
  span {
    font-size: 11px;
    color: #409eff;
  }
}
.page__list {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
    em {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      background: #fff;
      border: 1px solid #f56c6c;
      color: #f56c6c;
      border-radius: 50%;
      font-style: normal;
      font-size: 12px;
      font-weight: 600;
      margin-right: 10px;
      flex-shrink: 0;
      margin-top: 2px;
    }
    span {
      font-size: 13px;
      color: #606266;
      line-height: 1.6;
      flex: 1;
    }
  }
  .none {
    text-align: center;
    color: #c0c4cc;
    font-size: 13px;
    margin: 0;
    padding: 20px 0;
  }
}
.page__action {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
}
.detail-btn,
.contact-btn {
  margin-left: 12px;
  padding: 10px 12px;
  font-size: 13px;
  white-space: nowrap;
}
.detail-btn {
  background: #fff !important;
  border-color: #f56c6c !important;
  color: #f56c6c !important;
  .el-icon-arrow-right {
    margin-left: 6px;
    font-weight: 700;
  }
  &:hover,
  &:focus {
    background: #fef0f0 !important;
    border-color: #f56c6c !important;
    color: #f56c6c !important;
  }
}
.contact-btn {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
  color: #fff !important;
  &:hover,
  &:focus {
    background: #f78989 !important;
    border-color: #f78989 !important;
    color: #fff !important;
  }
}
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s;
  &:hover {
    background: #f56c6c;
    span {
      border-color: #fff;
    }
  }
  span {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-top: 2px solid #606266;
    border-left: 2px solid #606266;
    transition: all 0.3s;
  }
}
.nav-fade-enter-active,
.nav-fade-leave-active {
  transition: opacity 0.3s;
}
.nav-fade-enter,
.nav-fade-leave-to {
  opacity: 0;
}
.nav-prev {
  left: 12px;
  span {
    transform: rotate(-45deg);
    margin-left: 5px;
  }
}
.nav-next {
  right: 12px;
  span {
    transform: rotate(135deg);
    margin-right: 5px;
  }
}
.dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 10px 0 4px;
  flex-shrink: 0;
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #dcdfe6;
    cursor: pointer;
    transition: all 0.3s;
    &.on {
      background: #f56c6c;
      width: 24px;
      border-radius: 5px;
    }
    &:hover {
      background: #f56c6c;
    }
  }
}
</style>
